export type Role = 'tenant' | 'reception' | 'admin';

export interface Me {
  id: string;
  email: string;
  role: Role;
  siteId: string;
  companyId: string | null;
  companyName: string | null;
  firstName: string;
  lastName: string;
  language: 'sv' | 'en';
  twoFactorEnabled: boolean;
  reminderMinutes: number | null;
  calendarUrl: string;
  site: { name: string; brand: { primaryColor?: string }; hasLogo: boolean };
}

export interface Room {
  id: string;
  name: string;
  floor: number;
  capacity: number;
  equipment: string;
  layout: string;
  description: string;
  active: boolean;
  canBook: boolean;
  photoIds: string[];
  accessGroupIds: string[];
}

export interface Busy {
  roomId: string;
  start: string;
  end: string;
  kind: 'booking' | 'block';
  mine: boolean;
  bookingId: string | null;
  title: string | null;
  attendees: number | null;
  seriesId: string | null;
  person: string | null;
  company: string | null;
  reason: string | null;
}

export interface Booking {
  id: string;
  roomId: string;
  userId: string | null;
  createdBy: string | null;
  seriesId: string | null;
  title: string | null;
  attendees: number;
  start: string;
  end: string;
  status: 'active' | 'cancelled';
  cancelReason: string | null;
}

export const isStaff = (me: { role: Role }) => me.role === 'reception' || me.role === 'admin';
